// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ErrorComponent = require("../../../v5/common/Components/ErrorComponent.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function UserSessionFetchErrorMessage(props) {
  return JsxRuntime.jsx(ErrorComponent.Large.make, {
    children: "There was an error loading your profile. Please try refreshing and contact support if the problem persists"
  });
}

let make = UserSessionFetchErrorMessage;

exports.make = make;
/* ErrorComponent Not a pure module */
